import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { toInteger, isEmpty, map, toString } from 'lodash'

import { callApi } from '../services/fetchService'
import { getSelectOptions } from '../services/selectService'
import { loadGlobals } from '../actions'

import FaIcon from '../components/FaIcon'
import { Row, Col, Card, Form, Input, Button, Divider, Select, Spin, message } from 'antd'
const FormItem = Form.Item



class _ActionForm extends Component {

    static propTypes = {
        action: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    }
    
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onSubmit(values);
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { intl } = this.props

        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            style: { marginBottom: '10px' }
        }
        const tailFormItemLayout = {
            wrapperCol: { offset: 6, span: 18 },
            style: { marginTop: '25px' }
        }
        
        return (
            <Row gutter={24}>
                <Col lg={14}>
                    <Card title={<span><FaIcon icon="info-circle" /><FormattedMessage id="action.generalCard" /></span>}>
                        <Form layout="horizontal" onSubmit={this.handleSubmit}>
                            <FormItem label={<FormattedMessage id="action.name" />} {...formItemLayout}>
                                {getFieldDecorator('name', {
                                    rules: [{required: true, message: intl.formatMessage({id: 'action.nameRequired'})}]
                                })(<Input/>)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="action.category" />} {...formItemLayout}>
                                {getFieldDecorator('category', {
                                    rules: [{required: true, message: intl.formatMessage({id: 'action.categoryRequired'})}]
                                })(<Select showSearch optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getSelectOptions('action-categories', this.props.action.category)}
                                </Select>)}
                            </FormItem>
                            <Divider />
                            <FormItem {...tailFormItemLayout}>
                                <Button type="primary" loading={this.props.updating} htmlType="submit"><FormattedMessage id="misc.save" /></Button>
                            </FormItem>
                        </Form>
                    </Card>
                </Col>
                <Col lg={10}>
                    <Card title={<span><FaIcon icon="leaf" /><FormattedMessage id="action.plantsCard" /></span>}>
                        <Form layout="horizontal">
                            <FormItem>
                                {getFieldDecorator('plants')(<Select showSearch mode="multiple" style={{ width: '100%' }} optionFilterProp="children" placeholder={<FormattedMessage id="action.plantsPlaceholder" />} filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getSelectOptions('plants', this.props.action.plants)}
                                </Select>)}
                            </FormItem>
                        </Form>
                    </Card>
                </Col>
            </Row>
        )
    }

}

const ActionForm = injectIntl(Form.create({
    mapPropsToFields(props) {
        const plants = map(props.action.plants, toString)  // Select works only with string keys
        return {
            name: Form.createFormField({value: props.action.name}),
            category: Form.createFormField({value: props.action.category}),
            plants: Form.createFormField({value: plants})
        };
    }
})(_ActionForm))



/**
 * User view
 */

class Action extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired,
        loadGlobals: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }
    
    state = {
        actionId: null,
        action: {},
        formAction: {},
        loading: false,
        updating: false
    }

    fetch = () => {
        const { intl } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'actions/' + this.state.actionId
        }).then((data) => {
            this.setState({
                action: data,
                formAction: Object.assign({}, data),
                loading: false
            })
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentWillReceiveProps(nextProps) {
        let id = nextProps.match.params.id
        id = (id === undefined || id === null) ? null : toInteger(id)
        if (this.state.actionId !== id) {
            this.setState({ actionId: id }, () => {
                if (this.isNew()) {
                    this.setState({ action: {}, formAction: {} })
                } else {
                    this.fetch()
                }
            })
        }
    }

    componentWillMount() {
        let id = this.props.match.params.id
        id = (id === undefined || id === null) ? null : toInteger(id)
        this.setState({ actionId: id })
    }

    componentDidMount() {
        if (this.isNew()) {
            this.setState({ action: {}, formAction: {} })
        } else {
            this.fetch()
        }
    }

    saveAction = (action) => {
        const { intl, history } = this.props
        this.setState({
            formAction: Object.assign({}, this.state.formAction, action),
            updating: true
        })
        // Insert new
        if (this.isNew()) {
            callApi({
                endpoint: 'actions',
                body: action,
                method: 'PUT'
            }).then((data) => {
                this.setState({
                    actionId: data.id,
                    action: data,
                    formAction: Object.assign({}, data),
                    updating: false
                })
                message.success(this.props.intl.formatMessage({id: "misc.insertSuccess"}))
                history.push('/action/' + data.id)
                this.props.loadGlobals()
            }).catch((err) => {
                message.error(intl.formatMessage({id: 'misc.unknownError'}))
                this.setState({ updating: false })
            })
        }
        // Update
        else {
            callApi({
                endpoint: 'actions/' + this.state.actionId,
                body: action,
                method: 'POST'
            }).then((data) => {
                this.setState({
                    action: data,
                    formAction: Object.assign({}, data),
                    updating: false
                })
                message.success(this.props.intl.formatMessage({id: "misc.updateSuccess"}))
                this.props.loadGlobals()
            }).catch((err) => {
                message.error(intl.formatMessage({id: 'misc.unknownError'}))
                this.setState({ updating: false })
            })
        }
    }

    isNew = () => {
        return this.state.actionId === null || this.state.actionId === undefined
    }

    render() {
        const { action, loading, updating, formAction } = this.state
      
		if (!this.isNew() && (isEmpty(action) || loading)) {
			return (
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <Spin size="large" />
                </div>
            )
        }
        
        return (
            <div>
                {
                    this.isNew() ? <h1><FaIcon icon="bullseye" fixedWidth /><FormattedMessage id="action.titleNew"/></h1>
                    : <h1><FaIcon icon="bullseye" fixedWidth /> <FormattedMessage id="action.titleUpdate" values={action} /></h1>
                }
                <ActionForm action={formAction} onSubmit={this.saveAction} updating={updating} />
            </div>
        )
    }

}

export default injectIntl(withRouter(connect(null, {
    loadGlobals
})(Action)))


// WEBPACK FOOTER //
// ./src/views/Action.js